import api from '@/api';
import { API_BASE_URL } from '..';
import {
  InvoiceEditNFc,
  InvoiceEditNFe,
  InvoiceEditNFs,
} from './invoices.editTypes';
import {
  InvoiceCreateNFc,
  InvoiceCreateNFe,
  InvoiceCreateNFs,
} from './invoices.createTypes';
import {
  InvoiceAdditionalData,
  InvoiceData,
  InvoiceListParams,
} from './invoices.types';
import { PageResult } from '@/core/request/PageResult';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

// METHODS

export async function invoiceList(params: InvoiceListParams) {
  const result = (await api.get(CONTROLLER_URL, params)) as unknown;
  return result as PageResult<InvoiceData>;
}

export async function invoiceDetail(id?: number) {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;
  return result as InvoiceData;
}

export async function invoiceRemove(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;
  return result as void;
}

export async function invoiceAdditionalData({
  id,
  ...data
}: InvoiceAdditionalData) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/invoice/${id}/additional-data`,
    data,
    null,
  )) as unknown;
  return result as void;
}

export async function calculateTaxes(id: number) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${id}/calculate-all-taxes`,
    {},
    null,
  )) as unknown;

  return result as InvoiceData;
}

// NFS

export async function invoiceCreateNFs(data: InvoiceCreateNFs) {
  const result = (await api.post(`${CONTROLLER_URL}/Nfs`, data)) as unknown;
  return result as InvoiceData;
}

export async function invoiceEditNFs({ id, ...data }: InvoiceEditNFs) {
  const result = (await api.put(
    `${CONTROLLER_URL}/Nfs/${id}`,
    data,
    null,
  )) as unknown;
  return result as InvoiceData;
}

// NFE

export async function invoiceCreateNFe(data: InvoiceCreateNFe) {
  const result = (await api.post(`${CONTROLLER_URL}/Nfe`, data)) as unknown;
  return result as InvoiceData;
}

export async function invoiceEditNFe({ id, ...data }: InvoiceEditNFe) {
  const result = (await api.put(
    `${CONTROLLER_URL}/Nfe/${id}`,
    data,
    null,
  )) as unknown;
  return result as InvoiceData;
}

// NFC

export async function invoiceCreateNFc(data: InvoiceCreateNFc) {
  const result = (await api.post(`${CONTROLLER_URL}/Nfc`, data)) as unknown;
  return result as InvoiceData;
}

export async function invoiceEditNFc({ id, ...data }: InvoiceEditNFc) {
  const result = (await api.put(
    `${CONTROLLER_URL}/Nfc/${id}`,
    data,
    null,
  )) as unknown;
  return result as InvoiceData;
}
